import React from 'react'
import PropTypes from 'prop-types'
import { Card, colors } from '@fs/zion-ui'

/**
 * PrimaryEventWrapper
 *
 * Provides consistent gray Card wrapper for existing primary event content.
 * This is a structural component that ensures existing primary events
 * (those with existingEventId) have consistent visual treatment when
 * toggling between view and edit modes.
 *
 * Used only when field.primary && field.existingEventId.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to wrap in gray card
 * @returns {JSX.Element}
 */
const PrimaryEventWrapper = ({ children }) => {
  return (
    <Card edges="none" backgroundColor={colors.gray02} margins="xxs">
      {children}
    </Card>
  )
}

PrimaryEventWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}

export default PrimaryEventWrapper
